import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPolitikatIcon = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 18,
	height: 21.813,
	viewBox: "0 0 18 21.813",
	...props,
	children: /* @__PURE__ */ _jsx("g", {
		id: "Group_4766",
		"data-name": "Group 4766",
		transform: "translate(-3 -1.188)",
		children: /* @__PURE__ */ _jsxs("g", {
			id: "Group_4765",
			"data-name": "Group 4765",
			children: [/* @__PURE__ */ _jsx("path", {
				id: "Path_7620",
				"data-name": "Path 7620",
				d: "M21,6.3a2.008,2.008,0,0,0-1.19-1.83l-7-3.11a1.988,1.988,0,0,0-1.62,0l-7,3.11A2.008,2.008,0,0,0,3,6.3V11c0,5.55,3.84,10.74,9,12a11.329,11.329,0,0,0,5.88-3.71l-3.12-3.12a5,5,0,1,1,1.42-1.42l2.9,2.9A12.725,12.725,0,0,0,21,11Z",
				fill: "#fff"
			}), /* @__PURE__ */ _jsx("circle", {
				id: "Ellipse_1",
				"data-name": "Ellipse 1",
				cx: 3,
				cy: 3,
				r: 3,
				transform: "translate(9 9)",
				fill: "#fff"
			})]
		})
	})
});
export { SvgPolitikatIcon as ReactComponent };
